@if (message && !orchestration) {
  <app-page-shell>
    <app-page-data-panel title="Cross-Dock Orchestration" subtitle="The requested orchestration could not be opened.">
      <div class="empty-state">{{ message }}</div>
    </app-page-data-panel>
  </app-page-shell>
}

<app-page-shell *ngIf="orchestration as row">
  <app-page-detail-hero [auditStamp]="{ createdAt: row.createdAt, updatedAt: row.updatedAt }"
    eyebrow="Cross-Dock Orchestration"
    [title]="row.crossDockOrchestrationNumber || ('#' + row.crossDockOrchestrationId)"
    [subtitle]="(row.sourceType || 'Source') + ' ' + (row.sourceNumber || row.sourceId || '')"
    icon="fa-solid fa-network-wired">
    <div tags>
      <p-tag [value]="row.status || 'PLANNED'" [severity]="severity(row.status)"></p-tag>
      <p-tag [value]="(row.legCount || legs().length || 0) + ' legs'" severity="info"></p-tag>
    </div>
    <div actions>
      <p-button label="Orchestrations" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/transport-planning/orchestrations"></p-button>
      @if (row.parentReleaseId) {
        <p-button label="Parent Release" icon="pi pi-list-check" severity="secondary" [outlined]="true" [routerLink]="['/transport-planning/releases', row.parentReleaseId]"></p-button>
      }
    </div>
  </app-page-detail-hero>

  @if (row.cancelledAt) {
    <div class="cancellation-audit">Cancelled {{ row.cancelledAt | date:'medium' }} by {{ row.cancelledByActor?.name || 'Unknown actor' }}. Reason: {{ row.cancellationReason || 'Not recorded' }}</div>
  }

  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <app-page-data-panel
    title="Movement Chain"
    subtitle="Each leg is generated by the backend route engine and linked to either a warehouse transfer or final dispatch."
    [resultText]="legs().length + ' legs'">
    <div class="orchestration-summary">
      <div><span>Orchestration ID</span><strong>{{ row.crossDockOrchestrationId }}</strong></div>
      <div><span>Number</span><strong>{{ row.crossDockOrchestrationNumber || '-' }}</strong></div>
      <div><span>Created</span><strong>{{ date(row.createdAt) }}</strong></div>
      <div><span>Updated</span><strong>{{ date(row.updatedAt) }}</strong></div>
    </div>

    <div class="leg-chain">
      @for (leg of legs(); track leg.id || leg.legSequence || $index) {
        <article class="leg-card">
          <div class="leg-card-head">
            <p-tag [value]="legTitle(leg)" severity="info"></p-tag>
            <p-tag [value]="planningLabel(leg)" [severity]="planningSeverity(leg)"></p-tag>
          </div>
          <h3>{{ movementRoute(leg) }}</h3>
          <dl>
            <div><dt>Type</dt><dd>{{ leg.legType || '-' }}</dd></div>
            <div><dt>Release</dt><dd><a [routerLink]="['/transport-planning/releases', leg.releaseId]">{{ leg.releaseNumber || leg.releaseId || '-' }}</a></dd></div>
            <div><dt>Movement Doc</dt><dd>{{ movementNumber(leg) }}</dd></div>
            <div><dt>Warehouse movement</dt><dd>{{ statusLabel(leg) }}</dd></div>
            <div><dt>Execution gate</dt><dd>{{ receiptLabel(leg) }}</dd></div>
            <div><dt>Transfer ID</dt><dd>{{ leg.transferId || '-' }}</dd></div>
            <div><dt>Dispatch ID</dt><dd>{{ leg.dispatchId || '-' }}</dd></div>
            <div><dt>Gated By Transfer</dt><dd>{{ leg.gatedByTransferId || '-' }}</dd></div>
          </dl>
          @if (leg.blockedReason) {
            <p class="blocked-reason">{{ leg.blockedReason }}</p>
          }
        </article>
      }
    </div>

    <p-table [value]="legs()" responsiveLayout="scroll" styleClass="workspace-table leg-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Seq</th>
          <th>Type</th>
          <th>Route</th>
          <th>Release</th>
          <th>Transfer</th>
          <th>Dispatch</th>
          <th>Planning</th>
          <th>Warehouse movement</th>
          <th>Execution gate</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-leg>
        <tr>
          <td>{{ leg.legSequence || '-' }}</td>
          <td>{{ leg.legType || '-' }}</td>
          <td>{{ movementRoute(leg) }}</td>
          <td><a [routerLink]="['/transport-planning/releases', leg.releaseId]">{{ leg.releaseNumber || leg.releaseId || '-' }}</a></td>
          <td>{{ leg.transferNumber || leg.transferId || '-' }}</td>
          <td>{{ leg.dispatchNumber || leg.dispatchId || '-' }}</td>
          <td>
            <p-tag [value]="planningLabel(leg)" [severity]="planningSeverity(leg)"></p-tag>
            @if (leg.blockedReason) {
              <small class="blocked-reason-inline">{{ leg.blockedReason }}</small>
            }
          </td>
          <td><p-tag [value]="statusLabel(leg)" [severity]="severity(leg.status)"></p-tag></td>
          <td>{{ receiptLabel(leg) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="9" class="empty-state">No leg records are linked to this orchestration yet.</td></tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
